module.exports = __webpack_public_path__ + "img/avataaars.ff7abd60.png";